import React, { useState } from 'react';
import { FaLanguage, FaArrowLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import logo from '../../assets/finance7.png';
import Translator from './Essentials/Translator';

const Header = ({ onSidebarToggle }) => {
  const [showTranslator, setShowTranslator] = useState(false);

  const toggleTranslator = () => setShowTranslator(!showTranslator);

  return (
    <>
      <header className="fixed top-0 left-0 w-full bg-[#000300] shadow-md p-2 flex justify-between items-center z-50">
        {/* Mobile Menu Button */}
        <div className='pt-2.5'> 
          <button 
            onClick={onSidebarToggle} 
            className="text-white text-2xl focus:outline-none md:hidden px-2 hover:text-gray-300 transition-colors"
            aria-label="Toggle menu"
          >
            &#9776;
          </button>
        </div>
        
        {/* Logo - Center aligned on mobile, left-aligned on md and up */}
        <div className="flex-1 flex justify-center sm:justify-center md:justify-start ml-7 sm:ml-14 md:ml-0.5 lg:ml-0">
          <img 
            src={logo} 
            alt="Company Logo" 
            className="h-8 xs:h-9 sm:h-10 md:h-11 object-contain md:ml-2"
            style={{
              width: 'auto',
              maxWidth: '200px',
              minWidth: '140px'
            }}
          />
        </div>
        
        {/* Back Button - Matches Navbar Behavior */}
        <div className="flex items-center pt-1">
          {/* Desktop Version (md and up) */}
          <Link 
            to="/"
            className="hidden md:flex items-center gap-1 lg:gap-2 text-white hover:text-gray-400 transition-colors font-semibold text-sm lg:text-base whitespace-nowrap"
            aria-label="Go back"
          >
            <FaArrowLeft className="text-base lg:text-lg" />
            <span>Back</span>
          </Link>
          
          {/* Mobile Version (below md) */}
          <Link 
            to="/"
            className="md:hidden flex items-center t gap-1 text-white font-semibold text-xs sm:text-sm border border-gray-600 px-1.5 py-0.5 rounded-md hover:bg-gray-800 transition-all whitespace-nowrap"
            aria-label="Go back"
          >
            <FaArrowLeft className="text-xs" />
            <span>Back</span>
          </Link>
        </div>
      </header>

      {/* Translator Card Popup */}
      <Translator show={showTranslator} onClose={toggleTranslator} />
    </>
  );
};

export default Header;